import { Icons, TextArea, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { ICoworkersInfo, IUserInfo } from '../../Services/ResponseData';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import './Steps.scss';
import '../Fields/Fields.scss';
import { ArrowRight } from '@finam/web-ui-kit/Icons/Arrow';
import CommunititesWidget from '../CommunititesWidget';
import OffersWidget from '../OffersWidget';
import { ArrowlineDown } from '@finam/web-ui-kit/Icons';

const imageExtensions: string[] = require('image-extensions');

interface IProps {
    userGuid: string
}

interface IState {
    photo?: string
    coworkers: ICoworkersInfo[]
    userPhotoFile?: File,
    aboutItself?: string;
}

export default class SocialStep extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    private fileInput: React.RefObject<HTMLInputElement>;


    constructor(props: IProps) {
        super(props);
        this.state = {
            coworkers: []
        }
        this.fileInput = React.createRef();
    }

    componentDidMount(): void {
        const ws = new WebService(this.context.token);
        ws.GetPhoto().then((photo) => this.setState({ photo: photo }));
        ws.GetCoworkers().then(res => this.setState({ coworkers: res }));
        console.log(imageExtensions);
    }

    renderSection(tytle: string, body: JSX.Element): JSX.Element {
        return <div></div>
    }


    renderCoworkerItem(info: ICoworkersInfo, key: string): JSX.Element {
        return <div key={key} className="coworker_item">
            <div className='coworker_img'>
                <img className='coworker-img' src={`data:image/jpeg;base64,${info.photo}`} />
            </div>
            <div className='coworker_info'>
                <Typography variant='body16' weight='semiBold'>{info.firstName}</Typography>
                <Typography variant='body16'>{info.strPost}</Typography>
            </div>
        </div>
    }



    render(): React.ReactNode {
        return <div className='social-step'><Typography variant='h2' className='step-title'>Привет наш новый коллега</Typography>
            <Typography variant='body16' className='step-description'>Мы выбираем лучших специалистов и искренне гордимся, что ты стал составляющей коллектива. Желаем больших достижений в работе!</Typography>

            <div className='social-section'>
                <h4>Моё фото</h4>
                <div className='userimage_wrapper'  onClick={() => this.fileInput.current?.click()}>
                    <img className='userImage' src={!!this.state.photo ? `data:image/jpeg;base64,${this.state.photo}` : process.env.PUBLIC_URL + "/person.gif"} />
                    <div className='uploadImg'>
                        <ArrowlineDown />
                    </div>
                    <input ref={this.fileInput}
                        multiple={false}
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(event) => {
                            if (event.target.files && event.target.files.length > 0) {
                                const ws = new WebService(this.context.token);
                                ws.UploadPhoto(event.target.files[0]).then(_ => {
                                    ws.GetPhoto().then((photo) => this.setState({ photo: photo }));
                                })
                            }
                        }}
                        accept={imageExtensions.map(ext => `image/${ext}`).join(', ')}
                    />
                </div>
            </div>
            <div className='social-sections'>
                <div className='social-section'>
                    <h4>Мои коллеги</h4>
                    {this.state.coworkers.length > 0 &&
                        <div className='coworkers_body'>
                            {this.state.coworkers.map((c, i) => this.renderCoworkerItem(c, `coworker_${i}`))}
                        </div>
                    }</div>
                <div className='social-community'>
                    <h5>Наши сообщества</h5>
                    <p>Ты можешь присоединиться к действующему клубу или создать свое направление, собрав необходимое количество единомышленников </p>
                    <CommunititesWidget />
                </div>
                <div className='social-community'>
                    <h5>Предложения наших партнеров</h5>
                    <OffersWidget />
                </div>
            </div>
        </div>
    }
}